import moment from 'moment-timezone';
import * as enums from '../../utils/enums';
import React from 'react';
import InventoryUtils from '../../utils/inventory-utils';
import { Tooltip } from 'react-tippy';

export default function getInventoryTableColumns(context) {
    let roomTypeColumn = [];

    if (!!context.props.model.inventory.inventoryData)
        context.props.model.inventory.inventoryData.allocationByDay.forEach((daylyData) => {
            const rooms = context.props.model.inventory.hotel.roomCategories.find(
                (category) => category.id === context.props.model.inventory.roomCategoryId
            );
            roomTypeColumn = InventoryUtils.getRoomTypesSorted(
                daylyData.roomInventory.roomTypes,
                rooms.roomTypes
            ).map((roomType) => {
                return {
                    id: roomType.name.toLowerCase(),
                    Header: roomType.name,
                    accessor: (r) => {
                        let freesale = r.roomInventory.roomTypesFreesale ? r.roomInventory.roomTypesFreesale.find((t) => t.name === roomType.name) : null;
                        let allocation = r.roomInventory.roomTypes.find((t) => t.name === roomType.name).availableAllotment;
                        // if closed then set the available to 0 for both allocation and freesale
                        let allotments =
                            ( allocation < 0
                                ? 0
                                : allocation) +
                            ' ( ' +
                            (r.roomInventory.freesale.count == enums.CLOSED_ALLOCATION_FREESALE ||
                                freesale.availableAllotment < 0
                                ? 0
                                : freesale.availableAllotment) +
                            ' )';
                        return allotments;
                             },
                    maxWidth: 70,
                    headerStyle: {
                        border: 'none',
                        textAlign: 'left'
                    }
                };
            });
        });

    let columns = [
        {
            Header: 'Date',
            columns: [
                {
                    id: 'date',
                    Header: '',
                    accessor: (d) => {
                        return d.dateOfAllocation
                            ? moment.tz(d.dateOfAllocation, 'Europe/London').format('DD/MMM/YYYY')
                            : '';
                    },
                    maxWidth: 85,
                    headerStyle: {
                        border: 'none'
                    }
                }
            ]
        },
        {
            Header: 'Day',
            columns: [
                {
                    id: 'day',
                    Header: '',
                    accessor: (d) => {
                        return d.dateOfAllocation ? moment.tz(d.dateOfAllocation, 'Europe/London').format('dddd') : '';
                    },
                    maxWidth: 75,
                    style: {
                        borderRight: '1px solid #c3c3c3'
                    },
                    headerStyle: {
                        borderRight: '1px solid #c3c3c3'
                    }
                }
            ]
        },
        {
            Header: 'Availability per Room Type - Allocation (Freesale)',
            columns: [ ...roomTypeColumn ]
        },
        {
            Header: 'Allocation/Release',
            columns: [
                {
                    id: 'allocation-release',
                    Header: '',
                    accessor: (d) => {
                        return `${d.roomInventory.allotment.count == enums.CLOSED_ALLOCATION_FREESALE
                            ? 'C'
                            : d.roomInventory.allotment.count} / ${d.roomInventory.allotment.releaseDays ==
                        enums.CLOSED_ALLOCATION_FREESALE
                            ? 'C'
                            : d.roomInventory.allotment.releaseDays}`;
                    },
                    width: 115,
                    style: {
                        borderLeft: '1px solid #c3c3c3'
                    },
                    headerStyle: {
                        borderLeft: '1px solid #c3c3c3'
                    }
                }
            ]
        },
        {
            Header: 'Freesale/Release',
            columns: [
                {
                    id: 'freesale-release',
                    Header: '',
                    accessor: (d) => {
                        return `${d.roomInventory.freesale.count == enums.CLOSED_ALLOCATION_FREESALE
                            ? 'C'
                            : d.roomInventory.freesale.count > enums.OPEN_INFINITY_CHECK
                              ? '∞'
                              : d.roomInventory.freesale.count} / 
							${d.roomInventory.freesale.releaseDays == enums.CLOSED_ALLOCATION_FREESALE
                                ? 'C'
                                : d.roomInventory.freesale.releaseDays}`;
                    },
                    width: 108,
                    style: {
                        borderRight: '1px solid #c3c3c3'
                    },
                    headerStyle: {
                        borderRight: '1px solid #c3c3c3'
                    }
                }
            ]
        },

        {
            Header: 'Allocation',
            columns: [
                {
                    id: 'available-allocation',
                    Header: '',
                    accessor: (d) => 
                        d.roomInventory.bookedDetails
                            ?  d.roomInventory.bookedDetails.currentAllocationTotal + d.roomInventory.bookedDetails.allocationUsed === enums.CLOSED_ALLOCATION_FREESALE
                                ? 'C'
                                : d.roomInventory.allotment.count > 0 ?d.roomInventory.bookedDetails.currentAllocationTotal < 0 
                                    ? 0
                                    : d.roomInventory.bookedDetails.currentAllocationTotal:0
                            : 0
                    ,
                    maxWidth: 70,
                    headerStyle: {
                        border: 'none'
                    }
                }
            ]
        },
        {
            Header: 'Freesale',
            columns: [
                {
                    id: 'available-freesale',
                    Header: '',
                    accessor: (d) =>
                       
                        d.roomInventory.bookedDetails
                            ? d.roomInventory.bookedDetails.currentFreesaleTotal + d.roomInventory.bookedDetails.freesaleUsed == enums.CLOSED_ALLOCATION_FREESALE
                                ? 'C'
                                : d.roomInventory.bookedDetails.currentFreesaleTotal > enums.OPEN_INFINITY_CHECK
                                    ? '∞'
                                    : d.roomInventory.freesale.count > 0 ? d.roomInventory.bookedDetails.currentFreesaleTotal < 0 
                                        ? 0
                                        : d.roomInventory.bookedDetails.currentFreesaleTotal:0
                            : 0,
                    maxWidth: 70,
                    style: {
                        borderRight: '1px solid #c3c3c3'
                    },
                    headerStyle: {
                        borderRight: '1px solid #c3c3c3'
                    }
                }
            ]
        },
        {
            Header: 'Actions',
            columns: [
                {
                    id: 'actions',
                    Header: '',
                    Cell: (row) => (
                        <div>
                            <Tooltip title="Edit" position="top" animation="fade" arrow size="big" distance={15}>
                                <button
                                    className="btn btn-primary btn-xs"
                                    onClick={context.props.onEditClick.bind(context, row.original, row.index)}
                                    name="btn-edit"
                                    disabled={row.original.deleted || context.props.model.editIndex > -1}
                                    id={`btn-edit-${row.index}`}>
                                    <span className="glyphicon glyphicon-pencil" />
                                </button>
                            </Tooltip>{' '}
                            <Tooltip
                                title="View Bookings"
                                position="top"
                                animation="fade"
                                arrow
                                size="big"
                                distance={15}>
                                <button
                                    className="btn btn-primary btn-xs"
                                    onClick={context.props.onBooking.bind(this, row, context, row.index)}
                                    name="btn-edit"
                                    disabled={row.row._original.totalAdultPrice == 0}
                                    id={`btn-edit-${row.index}`}>
                                    <span className="fas fa-business-time" />
                                </button>
                            </Tooltip>
                        </div>
                    ),
                    maxWidth: 90
                }
            ]
        }
    ];
    return columns;
}
